/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

const HubspotEmbedForm = ({ portalId, formId, region = 'na2' }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://js-na2.hsforms.net/forms/embed/developer/243522351.js`;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          region,
        });
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [portalId, formId, region]);

  return (
    <div
      id={`form-${formId}`}
      className="hs-form-html"
      data-form-id={formId}
      data-portal-id={portalId}
      data-region={region}
    />
  );
};

export default HubspotEmbedForm;
